<gp-modal [closable]="true" #createEditModal size="md">
  <div class="gp-modal-title" test-id="template-title">
    <ng-template [ngIf]="editTemplate">
      <h5>
        {{ 'TEMPLATE.template_settings' | translate }}:
        <label>{{selectedTemplate.name}}</label>
      </h5>
    </ng-template>
    <ng-template [ngIf]="duplicateTemplate">
      <h5>
        {{ 'TEMPLATE.duplicate_template' | translate }}:
        <label>{{selectedTemplate.name}}</label>
      </h5>
    </ng-template>
    <ng-template [ngIf]="createTemplate">
      <h5>{{ 'TEMPLATE.create_new_template' | translate }}</h5>
    </ng-template>
  </div>

  <div class="gp-modal-body">
    <gp-message *ngIf="errorMessage" [text]="errorMessage | translate" type="danger"></gp-message>
    <form novalidate [formGroup]="templateForm" class="gp-modal-body clearfix">
      <div class="col-md-12">
        <div class="form-group">
          <label for="regulation">{{'COMMON.regulation' | translate }}
            <span class="required"> *</span>
          </label>
          <div>
            <gp-tree-select [placeholder]="'EMPLOYEE_HIRE.select_regulation' | translate"
                            [attr.test-id]="'templateRegulation'"
                            [tree]="regulationTree"
                            [isSorted]="false"
                            [readOnly]="editTemplate"
                            buttonClasses="btn-sm"
                            class="form-control"
                            formControlName="cliRegId"
                            id="regulation"
                            ngDefaultControl
                            test-id="template-cliRegName">
            </gp-tree-select>
            <ul class="error-list"
                [attr.data-hidden]="templateForm.controls.cliRegId.valid || templateForm.controls.cliRegId.pristine">
            </ul>
          </div>
        </div>
        <div class="form-group">
          <label for="locale">{{ 'SIGNIN.language' | translate }}
            <span class="required"> *</span>
          </label>
          <gp-dropdown-select
            [placeholder]="'TEMPLATE.select_language' | translate "
            [attr.test-id]="'selectTemplateLanguage'"
            buttonClasses="btn-sm"
            class="form-control no-b"
            formControlName="locale"
            id="language"
            ngDefaultControl
            test-id="template-locale">
            <gp-dropdown-option *ngFor="let lang of languages | keys"
                                [ngValue]="lang">
              {{ languages[lang] }}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
        <div class="form-group">
          <label for="name">{{'FORMS.name' | translate }}
            <span class="required">*</span>
          </label>
          <div>
            <input [placeholder]="'FORMS.name'| translate"
                   [attr.test-id]="'templateName'"
                   type="text"
                   class="form-control"
                   formControlName="name"
                   id="name"
                   test-id="template-name">
            <ul class="error-list"
                [attr.data-hidden]="templateForm.controls.name.valid || templateForm.controls.name.pristine">
              <li *ngIf="templateForm.controls.name.errors?.maxlength">
                {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: 50} }}
              </li>
            </ul>
          </div>
        </div>
        <div class="form-group">
          <label for="folder">{{'TEMPLATE.folder'| translate}}
            <span class="required">*</span>
          </label>
          <div>
            <gp-dropdown-select [placeholder]="'TEMPLATE.select_folder'| translate"
                                [attr.test-id]="'templateFolder'"
                                (click-outside)="resetFilterTextAndFolderNamesValues()"
                                buttonClasses="btn-sm"
                                class="form-control no-b"
                                formControlName="folder"
                                id="folder"
                                ngDefaultControl
                                test-id="template-folder">
              <div class="header-actions">
                <div class="header-actions--search form-group l-h m-a-0 m-x-xs">
                  <div class="search-box-with-icon">
                    <input #searchInput
                           [attr.test-id]="'newFolderSearch'"
                           (keyup)="filterFolderNames(searchInput.value)"
                           (keydown.enter)="$event.preventDefault()"
                           type="text" id="searchInput"
                           class="form-control"
                           placeholder="{{ 'NAVBAR.search' | translate }} ...">
                    <em class="fa fa-light fa-search"></em>
                  </div>
                </div>
                <div class="btn-bar btn-bar-sm btn-bar-align-end">
                  <button
                    [attr.test-id]="'newFolderCreateBtn'"
                    (click)=toggleNewFolderCreate()
                    type="submit"
                    class="btn btn-primary new-btn btn-sm pull-right m-t-n2">
                    <em class="fa fa-light fa-plus-circle"></em>
                    {{'TEMPLATE.create_new_folder' | translate}}
                  </button>
                </div>
              </div>
              <div class="list-scroll">
                <div *ngIf="createNewFolderToggle">
                  <em class="fa fa-light fa-folder folder-icon"> </em>
                  <input #newFolderInput
                         [attr.test-id]="'newFolderInput'"
                         (keydown.enter)="addNewFolder()"
                         placeholder="{{ 'TEMPLATE.new_folder' | translate }} ..."
                         type="text"
                         class="form-control new-folder"
                         id="newFolderName">
                </div>
                <gp-dropdown-option *ngFor="let folder of filteredFolderNames"
                                    [ngValue]="folder"
                                    (click)="resetFilterTextAndFolderNamesValues()">
                  <em class="fa fa-light fa-folder m-x-xs"></em>{{folder}}
                </gp-dropdown-option>
              </div>
            </gp-dropdown-select>
          </div>
          <div *ngIf="duplicateTemplate"
               class="alert alert-warning m-t-md">
            <em class="fa fa-light fa-exclamation-triangle"></em>
            {{ 'TEMPLATE.regulation_or_name_or_lang_must_be_changed_msg' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button [disabled]="isTemplateFormInValid()"
                (click)="onSubmit()"
                class="btn btn-dark p-x-md"
                test-id="btnCreateEdit">
          <ng-template [ngIf]="editTemplate || duplicateTemplate" [ngIfElse]="createTemplateSubmit">
            <em class="fa fa-light fa-save p-x-xs"></em>
            {{ 'TEMPLATE.save' | translate }}
          </ng-template>
          <ng-template #createTemplateSubmit>
            {{'MENU.COMPANY.create' | translate}}
          </ng-template>
        </button>
        <button (click)="createEditModal.close()"
                type="button"
                class="btn btn-secondary p-x-md"
                test-id="btnCancel">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
